<div class="loading-container" [ngClass]="{ hidden: hidden }">
  <app-ellipsis></app-ellipsis>
</div>
